
    // IMPORTS
    import { computed, defineComponent } from 'vue'
    import loginContent from './login-content.vue'
    import PartnerLoginForm from './partner-login-form.vue'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'PartnerLogin',

        components: {
            loginContent,
            PartnerLoginForm
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const title = computed(() => localize('ResellerLogin'))

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { title }
        }
    })
